<template>
  <section ref="contentData">
    <vs-row class="mb-3">
      <h1 class="title is-1 is-size-3-mobile has-text-left">
        {{ dataDetail.phone_name }}
      </h1>
    </vs-row>

    <!-- Harga -->
    <vs-row class="my-5">
      <!-- Kalau tidak ada array 12 -->
      <h3
        v-if="!dataDetail.specifications[12]"
        :disabled="(disabel = true)"
        class="subtitle is-3 is-size-4-mobile"
      ></h3>

      <!-- Kalau ada array 12, namun tidak ada price -->
      <p
        v-else-if="
          Object.assign({}, ...dataDetail.specifications[12].specs).key !==
          'Price'
        "
        :disabled="(disabel = true)"
      ></p>

      <!-- Kalau mata uang rupee -->
      <h3
        v-else-if="
          Object.assign(
            {},
            ...dataDetail.specifications[12].specs
          ).val[0].includes('₹')
        "
        class="subtitle is-3 is-size-4-mobile"
      >
        Rp
        {{
          Object.assign({}, ...dataDetail.specifications[12].specs)
            .val[0].slice(1)
            .replaceAll(",", "") *
          180 *
          quantity
        }}
      </h3>

      <!-- Kalau mata uang eur
          Kalau ada array 12 -->
      <h3
        v-else-if="
          Object.assign(
            {},
            ...dataDetail.specifications[12].specs
          ).val[0].includes('EUR')
        "
        class="subtitle is-3 is-size-4-mobile"
      >
        Rp
        {{
          Object.assign(
            {},
            ...dataDetail.specifications[12].specs
          ).val[0].slice(5, -3) *
          14000 *
          quantity
        }}
      </h3>

      <!-- Kalau mata uang C
          Kalau ada array 12 -->
      <h3
        v-else-if="
          Object.assign(
            {},
            ...dataDetail.specifications[12].specs
          ).val[0].includes('$')
        "
        class="subtitle is-3 is-size-4-mobile"
      >
        Rp
        {{
          Object.assign(
            {},
            ...dataDetail.specifications[12].specs
          ).val[0].slice(1, 5) *
          14400 *
          quantity
        }}
      </h3>

      <!-- Kalau mata uang Rp
          Kalau ada array 12 -->
      <h3
        v-else-if="
          Object.assign(
            {},
            ...dataDetail.specifications[12].specs
          ).val[0].includes('Rp')
        "
        class="subtitle is-3 is-size-4-mobile"
      >
        Rp
        {{
          Object.assign({}, ...dataDetail.specifications[12].specs)
            .val[0].slice(-9, -1)
            .replaceAll(",", "") *
          14400 *
          quantity
        }}
      </h3>

      <p v-else>Blum ada harga</p>
      <!-- <h3 class="subtitle is-3 is-size-4-mobile">Rp 24999000</h3> -->
    </vs-row>

    <!-- Btn Quantity -->
    <Input v-model="quantity" readonly class="has-text-centred">
      <template #prepend>
        <Button icon="md-remove" @click.native="decrement"></Button>
      </template>
      <template #append>
        <Button icon="md-add" @click.native="increment"></Button>
      </template>
    </Input>

    <!-- Btn Cart -->
    <vs-row class="my-5" vs-type="flex" vs-justify="center">
      <vs-col :lg="4" :xs="12">
        <Button
          @click.native="AddToCart"
          long
          size="large"
          type="primary"
          :loading="loading"
          >Add to Cart</Button
        >
      </vs-col>
    </vs-row>
  </section>
</template>

<script>
import axios from "axios";
import gql from "graphql-tag";

const ADD_CART = gql(
  `
  mutation MyMutation($objects: [cart_insert_input!] = {}) {
  insert_cart(objects: $objects) {
    returning {
      id_userName
      id
      phone_slug
      phone_name
      quantity
      price
      user {
        userName
      }
    }
  }
}

  `
);
export default {
  data() {
    return {
      quantity: 1,
      dataDetail: [],
      layar: "",
      loading: false,
    };
  },
  methods: {
    fetchDataDetail() {
      const loading = this.$vs.loading({
        text: "Mohon tunggu sebentar, sedang mengambil data...",
        target: this.$refs.contentData,
      });
      axios
        .get(
          `https://api-mobilespecs.azharimm.site/v2/${this.$route.params.detail}`
        )
        .then((response) => {
          console.log("hasil : ", response);
          this.dataDetail = response.data.data;
          loading.close();
        });
    },
    async AddToCart() {
      let Users = JSON.parse(localStorage.getItem("dataHp"));
      this.loading = true;

      //Check login or not
      if (Users) {
        if (!this.dataDetail.specifications[12]) {
          // alert("Barang kosong");
          this.disabel = true;
        } else {
          let TotalHarga;
          if (
            Object.assign(
              {},
              ...this.dataDetail.specifications[12].specs
            ).val[0].includes("₹")
          ) {
            TotalHarga =
              Object.assign({}, ...this.dataDetail.specifications[12].specs)
                .val[0].slice(1)
                .replaceAll(",", "") *
              180 *
              this.quantity;
          } else if (
            Object.assign(
              {},
              ...this.dataDetail.specifications[12].specs
            ).val[0].includes("EUR")
          ) {
            TotalHarga =
              Object.assign(
                {},
                ...this.dataDetail.specifications[12].specs
              ).val[0].slice(5, -3) *
              14000 *
              this.quantity;
          } else if (
            Object.assign(
              {},
              ...this.dataDetail.specifications[12].specs
            ).val[0].includes("$")
          ) {
            TotalHarga =
              Object.assign(
                {},
                ...this.dataDetail.specifications[12].specs
              ).val[0].slice(1, 5) *
              14400 *
              this.quantity;
          } else if (
            Object.assign(
              {},
              ...this.dataDetail.specifications[12].specs
            ).val[0].includes("C$")
          ) {
            TotalHarga =
              Object.assign(
                {},
                ...this.dataDetail.specifications[12].specs
              ).val[0].slice(1, 5) *
              14400 *
              this.quantity;
          } else if (
            Object.assign(
              {},
              ...this.dataDetail.specifications[12].specs
            ).val[0].includes("Rp")
          ) {
            TotalHarga =
              Object.assign({}, ...this.dataDetail.specifications[12].specs)
                .val[0].slice(-9, -1)
                .replaceAll(",", "") *
              14400 *
              this.quantity;
          }

          console.log("Total harga : ", TotalHarga);
          let hasilAddCart = await this.$apollo.mutate({
            mutation: ADD_CART,
            variables: {
              objects: {
                id_userName: Users.dataHp.UserLogin.id,
                phone_slug: this.$route.params.detail,
                image: this.dataDetail.thumbnail,
                quantity: this.quantity,
                phone_name: this.dataDetail.phone_name,
                price: TotalHarga,
              },
            },
          });
          console.log("Hasil Add to Cart : ", hasilAddCart);
          this.$Modal.success({
            title: "Berhasil masukkan ke cart",
          });
          this.loading = false;
        }
      } else {
        await setTimeout(
          (this.loading = false),
          this.$Modal.error({
            title: "Login Terlebih Dahulu",
            content:
              "Untuk menambahkan ke keranjang. mohon untuk login terlebih dahulu",
          }),
          2000
        );
        this.$router.push("/login");
      }
    },
    decrement() {
      if (this.quantity <= 1) {
        this.$Modal.error({
          title: "Tidak bisa 0",
          content: "Quantity yang dimasukkan tidak bisa lebih kecil dari 1",
        });
      } else {
        this.quantity -= 1;
      }
    },
    increment() {
      if (this.quantity >= 90) {
        this.$Modal.error({
          title: "Melebihi Stock",
          content: "Maaf quantity yang kamu masukkan melebihi stock",
        });
      } else {
        this.quantity += 1;
      }
    },
  },
  mounted() {
    this.fetchDataDetail();
  },
};
</script>

<style >
.vs-input {
  text-align: center;
}
</style>